import { OrganizationConnectionIntentListModel } from 'src/models/organizationConnectionIntent.models'
import { OrganizationIntegrationListModel } from 'src/models/organizationIntegration.models'
import { RootState } from 'src/redux/createRootReducer'

export const selectCreateOrgIntegrationLoadingFromState = (
  state: RootState,
): boolean => {
  return state.app.createOrgIntegration.loading
}

export const selectCreateOrgIntegrationErrorFromState = (
  state: RootState,
): boolean => {
  return state.app.createOrgIntegration.error
}

export const selectConnectionIntentFromState = (
  state: RootState,
): OrganizationConnectionIntentListModel | undefined => {
  return state.app.createOrgIntegration.connectionIntent !== undefined
    ? new OrganizationConnectionIntentListModel(
        state.app.createOrgIntegration.connectionIntent,
      )
    : undefined
}

export const selectOrgIntegrationFromState = (
  state: RootState,
): OrganizationIntegrationListModel | undefined => {
  return state.app.createOrgIntegration.orgIntegration !== undefined
    ? new OrganizationIntegrationListModel(
        state.app.createOrgIntegration.orgIntegration,
      )
    : undefined
}
